export class EasyEventEmitter<T extends { [on: string]: (...args: any[]) => void }> {
  private listeners: Map<keyof T, Set<T[keyof T]>> = new Map()

  on<K extends keyof T>(event: K, listener: T[K]): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)?.add(listener)
  }

  off<K extends keyof T>(event: K, listener: T[K]): void {
    this.listeners.get(event)?.delete(listener)
  }

  emit<K extends keyof T>(event: K, ...args: Parameters<T[K]>): void {
    this.listeners.get(event)?.forEach(listener => listener(...args))
  }
}
